import React from "react";

const RangeLowArrowIcon = ({ className, ...props }) => (
  <svg
    className={className}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path d="M7.16335 0.747125L1.49337 6.41711H3.9375C4.179 6.41711 4.375 6.61311 4.375 6.85461C4.375 7.09611 4.179 7.29211 3.9375 7.29211H0.4375C0.380333 7.29211 0.323686 7.28038 0.27002 7.25821C0.16327 7.21388 0.0782282 7.12884 0.0338949 7.02209C0.0117282 6.96842 0 6.91178 0 6.85461V3.35461C0 3.11311 0.196 2.91711 0.4375 2.91711C0.679 2.91711 0.875 3.11311 0.875 3.35461V5.79817L6.54498 0.128188C6.7159 -0.0427292 6.993 -0.0427292 7.16392 0.128188C7.33484 0.299104 7.33427 0.576208 7.16335 0.747125Z" />
  </svg>
);

export default RangeLowArrowIcon;
